import { rutaDeArea, rutaDeLinea } from '../serie';

/**
 * Una miniatura de tendencia, sin ejes ni números.
 *
 * Solo dice la forma: si lo que muestra la tarjeta viene subiendo, bajando o
 * dando saltos. Los valores exactos ya están en la tarjeta, y repetirlos en el
 * dibujo lo volvería un gráfico chico y difícil de leer.
 *
 * El `viewBox` fijo y `preserveAspectRatio="none"` estiran el dibujo al ancho
 * de la tarjeta; sin texto adentro, no hay nada que se deforme.
 */
export function Mini({ valores, color }: { valores: readonly number[]; color: string }) {
  const caja = { x: 1, y: 3, ancho: 118, alto: 26 };
  const max = Math.max(1, ...valores);
  if (valores.length < 2) return <svg className="mini" viewBox="0 0 120 32" aria-hidden="true" />;
  return (
    <svg className="mini" viewBox="0 0 120 32" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <path d={rutaDeArea(valores, caja, max)} style={{ fill: color }} opacity="0.14" />
      <path
        d={rutaDeLinea(valores, caja, max)}
        fill="none"
        style={{ stroke: color }}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
